import { captureFirstVisitParams } from '@/utils/tracking/firstVisitParams'
import { useMainStore } from '@/store'

// issue #755: 初回訪問時の流入元パラメータを捕捉する。
//
// tags.client.js のトラッキングタグ処理に相乗りしない理由:
//   - preventTrackingTags で除外されるページ(チケット受け取り等)でも流入元は取得したい
//   - ハードロード時の初回ナビゲーションでは router.afterEach が発火しないため、
//     プラグイン実行時点のルート(=広告からの着地URL)を直接処理する必要がある
export default defineNuxtPlugin(() => {
  const store = useMainStore()
  const router = useRouter()

  captureFirstVisitParams(router.currentRoute.value, store)
  router.afterEach(to => captureFirstVisitParams(to, store))
})
